/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodAnnoyed2 = createReactComponent("outline", "mood-annoyed-2", "IconMoodAnnoyed2", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M15 14c-2 0 -3 1 -3.5 2.05", "key": "svg-1" }], ["path", { "d": "M10 9.25c-.5 1 -2.5 1 -3 0", "key": "svg-2" }], ["path", { "d": "M17 9.25c-.5 1 -2.5 1 -3 0", "key": "svg-3" }]]);

export { IconMoodAnnoyed2 as default };
//# sourceMappingURL=IconMoodAnnoyed2.mjs.map
